import Vue from 'vue';
import router from '../../main';
import { checkPermisos } from '../../routes/subscription-routes';
const state = {

    nameRoute: "",
    jwt: "",
    apiUrl: "",
    dateTo: "",
    dateFrom: "",
    idBusiness: "",
    horaBusiness: "",
};

const mutations = {

    cambiarTpv(state,idTpv) {

        state.idTpv = idTpv;
    },

    'SET_NAME_ROUTE'(state, name) {
        state.nameRoute = name;
    },
    'SET_API_URL'(state, apiUrl) {
        state.apiUrl = apiUrl;
    },
    'SET_JWT'(state, jwt) {
        state.jwt = jwt;
    },
    'SET_LIST_BUSINESS'(state, listBusiness) {
        state.listBusiness = listBusiness;
    },
    'SET_DATE_TO'(state, dateTo) {
        state.dateTo = dateTo;
    },
    'SET_DATE_FROM'(state, dateFrom) {
        state.dateFrom = dateFrom;
    },
    'SET_ID_BUSINESS'(state, idBusiness) {
        state.idBusiness = idBusiness;
    },
    'SET_HORA_BUSINESS'(state, hora) {
        state.horaBusiness = hora;
    }

};

const actions = {
    setNameRoute: ({commit}, name) => {
        commit('SET_NAME_ROUTE', name);
    },
    setJWT: ({commit}, jwt) => {
        commit('SET_JWT', jwt);
    },
    setBusiness: ({commit}, business) => {
        commit('SET_ID_BUSINESS', business);
    },
    setApiUrl: ({commit}, apiUrl) => {
        commit('SET_API_URL', apiUrl);
    },
    setDateTo: ({commit}, dateTo) => {
        commit('SET_DATE_TO', dateTo);
    },
    setDateFrom: ({commit}, dateFrom) => {
        commit('SET_DATE_FROM', dateFrom);
    },
    setIdBusiness: ({commit}, idBusiness) => {
        commit('SET_ID_BUSINESS', idBusiness)
        checkPermisos(router.history.current);
    },
    setHoraBusiness: ({commit}, hora) => {
        commit('SET_HORA_BUSINESS', hora)
    }
};

const getters = {
    nameRoute: state => {
        return state.nameRoute;
    },
    jwt: state => {
        return state.jwt;
    },
    apiUrl: state => {
        return state.apiUrl;
    },
    dateTo: state => {
        return state.dateTo;
    },
    dateFrom: state => {
        return state.dateFrom;
    },
    idBusiness: state => {
        return state.idBusiness;
    },
    horaBusiness: state => {
        return state.horaBusiness;
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/general.js